import styled from 'styled-components'

export const Container = styled.div`
  width: ${p => p.width}px;

  .CircularProgressbar-path {
    stroke: ${p => p.progressColor }  !important;
  }

  .CircularProgressbar-trail {
    stroke: ${p => p.trackColor } !important;
  }
`